import { Component } from "react";

class ThankYouPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, proceeded: false, error: null };
  }

  getQueryParams() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return {
      userId: params.get("userId"),
      applicationId: params.get("applicationId"),
    };
  }

  async handleProceed() {
    const { userId, applicationId } = this.getQueryParams();
    if (!userId || !applicationId) return;

    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/onemoney/proceed`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId, applicationId }),
        },
      );
      if (!res.ok) throw new Error("Request failed");
      this.setState({ proceeded: true });
    } catch (e) {
      this.setState({ error: "Something went wrong. Please try again." });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, proceeded, error } = this.state;
    const { userId, applicationId } = this.getQueryParams();
    const showProceedButton = !!userId && !!applicationId;

    return (
      <div style={styles.overlay}>
        <div style={styles.card}>
          {/* Logo */}
          <div style={styles.logoWrap}>
            <img src="/img/logo.png" alt="MoneyMonk" style={styles.logo} />
          </div>

          {/* Illustration */}
          <div style={styles.illustrationWrap}>
            <svg
              viewBox="0 0 340 240"
              xmlns="http://www.w3.org/2000/svg"
              style={styles.illustration}
              aria-hidden="true"
            >
              {/* Background dots */}
              <circle cx="30" cy="50" r="6" fill="#c4aff5" opacity="0.6" />
              <circle cx="310" cy="60" r="5" fill="#c4aff5" opacity="0.6" />
              <circle cx="60" cy="200" r="4" fill="#c4aff5" opacity="0.5" />
              <circle cx="290" cy="190" r="4" fill="#c4aff5" opacity="0.5" />
              <circle cx="170" cy="20" r="5" fill="#c4aff5" opacity="0.5" />

              {/* Phone Frame */}
              <rect
                x="120"
                y="25"
                width="100"
                height="175"
                rx="14"
                ry="14"
                fill="#fff"
                stroke="#9d76e8"
                strokeWidth="3"
              />
              <rect
                x="125"
                y="38"
                width="90"
                height="140"
                rx="5"
                ry="5"
                fill="#f3eeff"
              />
              {/* Phone top notch */}
              <rect
                x="150"
                y="30"
                width="40"
                height="5"
                rx="3"
                fill="#9d76e8"
              />
              {/* Phone bottom button */}
              <circle cx="170" cy="192" r="5" fill="#9d76e8" />

              {/* Screen — image placeholder */}
              <rect
                x="130"
                y="44"
                width="80"
                height="45"
                rx="4"
                fill="#c4aff5"
                opacity="0.7"
              />
              <polygon
                points="155,62 175,44 195,62"
                fill="#9d76e8"
                opacity="0.5"
              />
              <circle cx="143" cy="56" r="7" fill="#9d76e8" opacity="0.6" />

              {/* Screen — text lines */}
              <rect
                x="130"
                y="95"
                width="80"
                height="6"
                rx="3"
                fill="#9d76e8"
                opacity="0.5"
              />
              <rect
                x="130"
                y="106"
                width="60"
                height="5"
                rx="3"
                fill="#9d76e8"
                opacity="0.4"
              />
              <rect
                x="130"
                y="116"
                width="70"
                height="5"
                rx="3"
                fill="#9d76e8"
                opacity="0.4"
              />

              {/* Search bar */}
              <rect
                x="130"
                y="130"
                width="80"
                height="14"
                rx="7"
                fill="#fff"
                stroke="#9d76e8"
                strokeWidth="1"
              />
              <circle cx="203" cy="137" r="4" fill="#9d76e8" />
              <line
                x1="206"
                y1="140"
                x2="209"
                y2="143"
                stroke="#9d76e8"
                strokeWidth="1.5"
              />

              {/* Play button */}
              <circle cx="170" cy="152" r="12" fill="#7c4fe0" opacity="0.9" />
              <polygon points="166,147 178,152 166,157" fill="#fff" />

              {/* Lock icon */}
              <rect
                x="60"
                y="90"
                width="32"
                height="32"
                rx="6"
                fill="#7c4fe0"
                opacity="0.9"
              />
              <rect x="69" y="99" width="14" height="12" rx="3" fill="#fff" />
              <path
                d="M71 99 Q76 92 81 99"
                stroke="#fff"
                strokeWidth="2.5"
                fill="none"
              />

              {/* Code icon */}
              <rect
                x="72"
                y="140"
                width="32"
                height="32"
                rx="6"
                fill="#fff"
                stroke="#9d76e8"
                strokeWidth="1.5"
              />
              <text
                x="80"
                y="161"
                fontSize="13"
                fill="#7c4fe0"
                fontFamily="monospace"
              >
                {"<>"}
              </text>

              {/* Hashtag icon */}
              <rect
                x="236"
                y="90"
                width="32"
                height="32"
                rx="6"
                fill="#7c4fe0"
                opacity="0.9"
              />
              <text
                x="244"
                y="112"
                fontSize="18"
                fill="#fff"
                fontFamily="Arial"
              >
                #
              </text>

              {/* Profile icon */}
              <rect
                x="236"
                y="140"
                width="32"
                height="32"
                rx="6"
                fill="#fff"
                stroke="#9d76e8"
                strokeWidth="1.5"
              />
              <circle cx="252" cy="153" r="5" fill="#7c4fe0" opacity="0.7" />
              <path
                d="M241 171 Q252 163 263 171"
                stroke="#7c4fe0"
                strokeWidth="2"
                fill="none"
                opacity="0.7"
              />

              {/* Clock icon */}
              <circle cx="290" cy="50" r="18" fill="#7c4fe0" opacity="0.9" />
              <circle cx="290" cy="50" r="13" fill="#fff" />
              <line
                x1="290"
                y1="42"
                x2="290"
                y2="50"
                stroke="#7c4fe0"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="290"
                y1="50"
                x2="297"
                y2="56"
                stroke="#7c4fe0"
                strokeWidth="2"
                strokeLinecap="round"
              />

              {/* Left person (kneeling, reaching toward phone) */}
              <circle cx="68" cy="155" r="12" fill="#f5b98e" />
              <path d="M56 149 Q68 140 80 149" fill="#3d2b1f" />
              <rect
                x="58"
                y="166"
                width="20"
                height="28"
                rx="5"
                fill="#7c4fe0"
              />
              <rect
                x="58"
                y="190"
                width="9"
                height="22"
                rx="4"
                fill="#3d2b1f"
                transform="rotate(-15, 62, 195)"
              />
              <rect
                x="69"
                y="190"
                width="9"
                height="18"
                rx="4"
                fill="#3d2b1f"
              />
              <line
                x1="58"
                y1="175"
                x2="115"
                y2="148"
                stroke="#f5b98e"
                strokeWidth="8"
                strokeLinecap="round"
              />
              <line
                x1="78"
                y1="174"
                x2="82"
                y2="195"
                stroke="#f5b98e"
                strokeWidth="7"
                strokeLinecap="round"
              />

              {/* Right person (standing at laptop) */}
              <rect
                x="230"
                y="195"
                width="60"
                height="6"
                rx="3"
                fill="#b0a0d0"
              />
              <rect
                x="240"
                y="165"
                width="42"
                height="30"
                rx="4"
                fill="#fff"
                stroke="#ccc"
                strokeWidth="1.5"
              />
              <rect
                x="244"
                y="168"
                width="34"
                height="22"
                rx="2"
                fill="#ede8fc"
              />
              <rect
                x="247"
                y="172"
                width="28"
                height="3"
                rx="1"
                fill="#9d76e8"
              />
              <rect
                x="247"
                y="178"
                width="20"
                height="3"
                rx="1"
                fill="#9d76e8"
              />
              <rect
                x="247"
                y="184"
                width="24"
                height="3"
                rx="1"
                fill="#9d76e8"
              />
              <circle cx="260" cy="143" r="12" fill="#f5b98e" />
              <path d="M248 138 Q260 129 272 138" fill="#3d2b1f" />
              <rect
                x="250"
                y="154"
                width="20"
                height="28"
                rx="5"
                fill="#8731E8"
              />
              <line
                x1="250"
                y1="162"
                x2="238"
                y2="178"
                stroke="#f5b98e"
                strokeWidth="7"
                strokeLinecap="round"
              />
              <line
                x1="270"
                y1="162"
                x2="278"
                y2="178"
                stroke="#f5b98e"
                strokeWidth="7"
                strokeLinecap="round"
              />
              <rect
                x="252"
                y="180"
                width="8"
                height="22"
                rx="4"
                fill="#3d2b1f"
              />
              <rect
                x="262"
                y="180"
                width="8"
                height="22"
                rx="4"
                fill="#3d2b1f"
              />

              {/* Decorative plant */}
              <rect
                x="28"
                y="195"
                width="22"
                height="18"
                rx="3"
                fill="#b0a0d0"
              />
              <path d="M39 195 Q28 170 42 160 Q44 178 39 195" fill="#6ab04c" />
              <path d="M39 195 Q52 168 44 155 Q38 172 39 195" fill="#4caf50" />
            </svg>
          </div>

          {/* Thank You Section */}
          <div style={styles.thankSection}>
            <h2 style={styles.thankHeading}>Almost there!</h2>
            <p style={styles.thankText}>
              We are reviewing.. Tap <strong>Proceed</strong> to notify the app and continue your
              loan application.
            </p>
          </div>

          {/* Proceed Button */}
          {showProceedButton && (
            <div style={styles.proceedSection}>
              {proceeded ? (
                <p style={styles.proceededText}>
                  Your application is being processed!
                </p>
              ) : (
                <>
                  {error && <p style={styles.errorText}>{error}</p>}
                  <button
                    style={
                      loading
                        ? { ...styles.proceedBtn, ...styles.proceedBtnDisabled }
                        : styles.proceedBtn
                    }
                    onClick={() => this.handleProceed()}
                    disabled={loading}
                  >
                    {loading ? "Please wait..." : "Proceed"}
                  </button>
                </>
              )}
            </div>
          )}

          {/* Contact Info */}
          <div style={styles.contactSection}>
            <p style={styles.contactLabel}>
              If you have a problem, please contact us:
            </p>
            <a style={styles.contactEmail}>support@moneymonk.in</a>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  overlay: {
    minHeight: "100vh",
    background: "#f6f9fe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    boxSizing: "border-box",
  },
  card: {
    background: "#ffffff",
    borderRadius: "20px",
    maxWidth: "420px",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 12px 48px rgba(124, 79, 224, 0.15)",
  },
  closeBtn: {
    position: "absolute",
    top: "14px",
    right: "16px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#7c4fe0",
    lineHeight: 1,
    padding: "4px 6px",
    zIndex: 10,
    fontWeight: "700",
  },
  logoWrap: {
    textAlign: "center",
    padding: "32px 24px 0",
  },
  logo: {
    height: "44px",
    objectFit: "contain",
  },
  illustrationWrap: {
    padding: "16px 24px 8px",
    textAlign: "center",
  },
  illustration: {
    width: "100%",
    maxWidth: "320px",
    height: "auto",
  },
  thankSection: {
    background: "#f3eeff",
    padding: "24px 32px",
    textAlign: "center",
    borderTop: "1px solid #e0d0f8",
    borderBottom: "1px solid #e0d0f8",
  },
  thankHeading: {
    color: "#7c4fe0",
    fontWeight: "700",
    fontSize: "22px",
    marginBottom: "12px",
    marginTop: 0,
  },
  thankText: {
    color: "#444",
    fontSize: "15px",
    lineHeight: "1.6",
    margin: "0 0 10px 0",
  },
  thankSubText: {
    color: "#444",
    fontSize: "15px",
    margin: 0,
  },
  contactSection: {
    padding: "18px 24px 22px",
    textAlign: "center",
  },
  contactLabel: {
    color: "#aaa",
    fontSize: "13px",
    margin: "0 0 4px 0",
  },
  contactEmail: {
    color: "#7c4fe0",
    fontWeight: "600",
    fontSize: "14px",
    textDecoration: "none",
  },
  proceedSection: {
    padding: "16px 24px 8px",
    textAlign: "center",
  },
  proceedBtn: {
    background: "#7c4fe0",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "13px 48px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    width: "100%",
  },
  proceedBtnDisabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  proceededText: {
    color: "#4caf50",
    fontWeight: "600",
    fontSize: "15px",
    margin: 0,
  },
  errorText: {
    color: "#e53935",
    fontSize: "13px",
    marginBottom: "8px",
  },
};

export default ThankYouPage;
